import type { SitecorePageFields } from '@/cms/fields/types/common'
import { SUMMER_PATHS, TEMPLATE_NAMES } from '@/constants'

export function isSummerPDP(pageProps: { page: { template: string }, fields: SitecorePageFields }) {
  return pageProps?.page?.template === TEMPLATE_NAMES.PDP && isSummerPage(pageProps?.fields?._url)
}

function isSummerPage(urlPath: string) {
  if (!urlPath) {
    return false
  }

  for (const path of SUMMER_PATHS) {
    if (urlPath.startsWith(path)) {
      return true
    }
  }
  return false
}
